<template>
  <div class="grid-view__cell" :class="{ 'cell-error': value === 'NaN' }">
    <div class="grid-field-number">
      <template v-if="value === 'NaN'">
        {{ $t('fieldErrors.invalidNumber') }}
      </template>
      <SearchHighlightedText
        v-else
        :text="formatFrontendNumber(field, value)"
        :search-term="searchTerm"
      />
    </div>
  </div>
</template>

<script>
import { formatDecimalNumber } from '@baserow/modules/database/utils/number'
import SearchHighlightedText from '@baserow/modules/database/components/view/grid/fields/SearchHighlightedText'

export default {
  name: 'FunctionalGridViewFieldNumber',
  components: { SearchHighlightedText },
  props: {
    field: {
      type: Object,
      required: true,
    },
    value: {
      type: null,
      default: null,
    },
    searchTerm: {
      type: String,
      required: false,
      default: '',
    },
  },
  methods: {
    formatFrontendNumber(field, value) {
      return formatDecimalNumber(field, value)
    },
  },
}
</script>
